// import { mockLegalConsentsResponse } from './LegalConsentsOCJLatestContent.mock';

// export const mockLegalConsentsProps = mockLegalConsentsResponse;

export const mockLegalConsentsProps = {
  data: {
    consentsSectionList: {
      items: [
        {
          gOpenInANewTabSuffix: ', opens in a new window',
          gOpenInAModalSuffix: ', opens in a modal',
          gOpenAccordionBtnLabel: 'Show More',
          gCloseAccordionBtnLabel: 'Show Less',
          consentsList: [
            // ...mockLegalConsentsResponse.data.consentsSectionList.items[0].consentsList,
            {
              id: 'china-required-consents-data',
              name: 'china-required-consents-data',
              index: 2,
              countries: ['CN'],
              options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
              sectionType: 'required',
              showTopDivider: false,
              showBottomDivider: false,
              containerClassName: 'm-china-consents ml-5 my-0',
              containerClassNameOverride: null,
              errorMessage: 'Please check all required consents!',
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [],
              checkboxes: [
                {
                  id: 'chinaNewCollectPersonalDataConsentRequired',
                  name: 'chinaNewCollectPersonalDataConsentRequired',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: 'm-china-consent-checkbox',
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I confirm that I am at least 18 years old. I agree to the Marriott Group’s Terms of Use and Loyalty Program Terms & Conditions. I also agree to the Marriott Group’s processing of my personal data in accordance with Mainland China Privacy Statement, including but not limited to the following data processing activities. (Required)',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: 'Please select required consents!',
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'chinaNewPersonalDataProvisionConsentRequiredData',
                  name: 'chinaNewPersonalDataProvisionConsentRequiredData',
                  index: 2,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: 'm-china-consent-checkbox',
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I agree to the cross-border transfers of my personal data by the Marriott Group. (Required)',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: 'Please select mandatory consents!',
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'chinaNewPersonalDataProvisionConsentRequiredContent',
                  name: 'chinaNewPersonalDataProvisionConsentRequiredContent',
                  index: 3,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: 'm-china-consent-checkbox',
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I agree to the processing of my sensitive personal data by the Marriott Group. (Required)',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'chinaNewRequiredContent',
                  name: 'chinaNewRequiredContent',
                  index: 3,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: 'm-china-consent-checkbox',
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      ' agree to the provision of my personal data to third parties by the Marriott Group. (Required)',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'china-optional-consents',
              name: 'china-optional-consents',
              index: 3,
              countries: ['CN'],
              options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
              sectionType: 'optional',
              showTopDivider: false,
              showBottomDivider: false,
              containerClassName: 'm-china-consents ml-5 my-0',
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [],
              checkboxes: [
                {
                  id: 'chinaNewCollectPersonalDataConsentOptional',
                  name: 'chinaNewCollectPersonalDataConsentOptional',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: 'm-china-consent-checkbox',
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I agree to receive account updates, program news and offers from the Marriott Group. (Optional)',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'chinaNewPersonalDataProvisionConsentOptional',
                  name: 'chinaNewPersonalDataProvisionConsentOptional',
                  index: 2,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: 'm-china-consent-checkbox',
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I agree to Marriott Group’s provision of my personal data with Authorized Licensees (as described in the Mainland China Privacy Statement) for marketing purpose. (Optional)',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'japan-vietnam-optional-consents',
              name: 'japan-vietnam-optional-consents',
              index: 1,
              countries: ['JP', 'VN', 'JP', 'VN'],
              options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
              sectionType: 'optional',
              showTopDivider: false,
              showBottomDivider: false,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [
                {
                  id: 'optinal-header-vietnam',
                  name: 'optinal-header-vietnam',
                  index: 1,
                  forCountries: ['VN'],
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  headerContainerClassName: null,
                  headerContainerClassNameOverride: null,
                  header: null,
                  headerClassName: null,
                  headerClassNameOverride: null,
                  subHeader: null,
                  subHeaderClassName: null,
                  subHeaderClassNameOverride: null,
                  description:
                    'I understand by providing ALL of the optional consents below, I can receive information relating to offers or promotions from the Marriott Group and third parties. I understand that I may deny consent, in which case I may be unable to receive such information. However, other products and services provided by the Marriott Group will continue to be available.',
                  descriptionClassName: null,
                  descriptionClassNameOverride: null,
                },
              ],
              checkboxes: [
                {
                  id: 'jpPersonalDataRequired-first',
                  name: 'jpPersonalDataRequired-first',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: ['join-now', 'bulgaria'],
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I would like to receive personalized communications, including offers, details about promotions, and travel-related products from the Marriott Group via email, mobile phone notifications, text messages, and other channels, as described in the Global Privacy Statement.\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'jpSharePersonalData-first',
                  name: 'jpSharePersonalData-first',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: ['join-now'],
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I would like for the Marriott Group to share my personal data with Authorized Licensees, as defined in the Global Privacy Statement so I may receive offers and marketing via email.\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'jpPersonalDataRequired',
                  name: 'jpPersonalDataRequired',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: ['join-now'],
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I would like to receive personalized communications, including offers, details about promotions, and travel-related products from the Marriott Group via email, mobile phone notifications, text messages, and other channels, as described in the Global Privacy Statement.\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'jpSharePersonalData',
                  name: 'jpSharePersonalData',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: ['join-now'],
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I would like for the Marriott Group to share my personal data with Authorized Licensees so I may receive personalized offers and marketing via email, mobile phone notifications, text messages, and other channels, as described in the Global Privacy Statement\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },

            {
              id: 'japan-required-consents',
              name: 'japan-required-consents',
              index: 2,
              countries: ['JP'],
              options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
              sectionType: 'required',
              showTopDivider: false,
              showBottomDivider: false,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [],
              checkboxes: [
                {
                  id: 'jpCrossBorderPersonalDataRequired-first',
                  name: 'jpCrossBorderPersonalDataRequired-first',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: ['join-now'],
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: true,
                  showCheckbox: false,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'By registering, I agree to the <a href=\\"/about/terms-of-use-modal.mi\\" target=\\"_parent\\"><u>Marriott Terms and Conditions</u></a> and the Marriott Bonvoy <a href=\\"/loyalty/terms.mi\\" target=\\"_parent\\"><u>Terms and Conditions</u></a>. I also consent to the collection, use, sharing of my personal data with third parties and transfer of my personal data internationally in accordance with Marriott\\\'s <a href=\\"/marriott/privacy-modal.mi\\" target=\\"_parent\\"><u>Global Privacy Statement</u></a>. I am aware that my personal data may be transferred to the location where <a href=\\"/about/privacy/marriott-group/modal.mi\\" target=\\"_parent\\"><u>Marriott Group</u></a> entities are located, and that further information on data protection in each region can be found at <a href=\\"https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/#gaikoku\\" target=\\"_blank\\"><u>Personal Information Protection Commission (PPC)</u></a> I understand that you can refer to the website of the website.\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'jpCrossBorderPersonalDataRequired',
                  name: 'jpCrossBorderPersonalDataRequired',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: ['non-member-reservation-instant-join'],
                  excludeOptions: ['reservation'],
                  isDisabled: false,
                  defaultChecked: true,
                  showCheckbox: false,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'By signing up, I agree to Marriott’s <a href="/about/terms-of-use-modal.mi" target="_blank">Terms of Use</a> and <a href="/loyalty/terms.mi" target="_blank">Marriott Bonvoy Terms and Conditions</a>. I also agree to my personal data being collected, used, shared with third parties, and transferred globally in accordance with Marriott’s <a href="/marriott/privacy-modal.mi" target="_blank">Global Privacy Statement</a>. I understand that my personal data may be transferred to locations in which <a href="/about/privacy/marriott-group/modal.mi" target="_blank">Marriott Group</a> entities are located, and that I may refer to the <a href="https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/#gaikoku" target="_blank" class="external-site">PPC’s website<span aria-hidden="true" class="t-icon-external-site"></span></a> for more information about data protection in various locations.\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'south-korea-optional-consents-join-now',
              name: 'south-korea-optional-consents-join-now',
              index: 4,
              countries: ['KR', 'KR'],
              options: ['join-now'],
              sectionType: 'optional',
              showTopDivider: false,
              showBottomDivider: false,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [
                {
                  id: 'south-korea-optional-consents-join-now-headers',
                  name: 'south-korea-optional-consents-join-now-headers',
                  index: 4,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  headerContainerClassName: null,
                  headerContainerClassNameOverride: null,
                  header: null,
                  headerClassName: null,
                  headerClassNameOverride: null,
                  subHeader: null,
                  subHeaderClassName: null,
                  subHeaderClassNameOverride: null,
                  description:
                    'I understand by providing ALL of the three consents below, I can receive information relating to offers or promotions from the Marriott Group and third parties. I understand that I may deny consent, in which case I may be unable to receive such information. However, other products and services provided by the Marriott Group will continue to be available.',
                  descriptionClassName: null,
                  descriptionClassNameOverride: null,
                },
              ],
              checkboxes: [
                {
                  id: 'skrCollectPersonalDataConsentOptional',
                  name: 'skrCollectPersonalDataConsentOptional',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'Consent to collection and use of Personal Data for personalized services (Optional)\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/personalDataUseMarketing.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'skrPersonalDataProvisionConsentOptional',
                  name: 'skrPersonalDataProvisionConsentOptional',
                  index: 2,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'Consent to provision of Personal Data to third parties for personalized services (Optional)\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/provisionDataUseMarketing.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'skrCrossBorderPersonalDataOptional',
                  name: 'skrCrossBorderPersonalDataOptional',
                  index: 3,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'Consent to cross-border transfer of Personal Data for personalized services (Optional)\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/consentCrossBorderuseMarketing.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'south-korea-optional-consents',
              name: 'south-korea-optional-consents',
              index: 3,
              countries: ['KR'],
              options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
              sectionType: 'optional',
              showTopDivider: false,
              showBottomDivider: false,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [
                {
                  id: 'south-korea-optional-consent-headers',
                  name: 'south-korea-optional-consent-headers',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  headerContainerClassName: null,
                  headerContainerClassNameOverride: null,
                  header: null,
                  headerClassName: null,
                  headerClassNameOverride: null,
                  subHeader: 'Don’t miss account updates, program news and exclusive savings offers.',
                  subHeaderClassName: null,
                  subHeaderClassNameOverride: null,
                  description:
                    'I understand by providing ALL of the optional consents below, I can receive information relating to offers or promotions from the Marriott Group and third parties. I understand that I may deny consent, in which case I may be unable to receive such information. However, other products and services provided by the Marriott Group will continue to be available.',
                  descriptionClassName: null,
                  descriptionClassNameOverride: null,
                },
              ],
              checkboxes: [
                {
                  id: 'collectPersonalDataConsentOptional',
                  name: 'collectPersonalDataConsentOptional',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown: 'Consent to collection and use of Personal Data for marketing purposes (Optional)\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/personalDataUseMarketing.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'personalDataProvisionConsentOptional',
                  name: 'personalDataProvisionConsentOptional',
                  index: 2,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'Consent to provision of Personal Data to third parties for marketing purposes (Optional)\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/provisionDataUseMarketing.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'crossBorderPersonalDataOptional',
                  name: 'crossBorderPersonalDataOptional',
                  index: 3,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'Consent to cross-border transfer of Personal Data for marketing purposes (Optional)\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/consentCrossBorderuseMarketing.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'electronicMarketingConsentOptional',
                  name: 'electronicMarketingConsentOptional',
                  index: 4,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown: "'Consent to electronic receipt of marketing information (Optional)\n\n ",
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/consentMarketingChannel.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'south-korea-privacy-consents-data',
              name: 'south-korea-privacy-consents-data',
              index: 1,
              countries: ['KR', 'KR'],
              options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
              sectionType: 'agreeAll',
              showTopDivider: true,
              showBottomDivider: true,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [
                {
                  id: 'south-korea-privacy-consents-consents-headers',
                  name: 'south-korea-privacy-consents-consents-headers',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: ['join-now'],
                  headerContainerClassName: null,
                  headerContainerClassNameOverride: null,
                  header: 'Privacy Consents Test',
                  headerClassName: null,
                  headerClassNameOverride: 'm-header-override',
                  subHeader: null,
                  subHeaderClassName: null,
                  subHeaderClassNameOverride: null,
                  description: null,
                  descriptionClassName: null,
                  descriptionClassNameOverride: null,
                },
                {
                  id: 'south-korea-privacy-consents-consents-join-now-headers',
                  name: 'south-korea-privacy-consents-consents-join-now-headers',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: ['join-now'],
                  excludeOptions: null,
                  headerContainerClassName: 'm-garker-background',
                  headerContainerClassNameOverride: null,
                  header: 'Privacy Consents',
                  headerClassName: null,
                  headerClassNameOverride: null,
                  subHeader: null,
                  subHeaderClassName: null,
                  subHeaderClassNameOverride: null,
                  description: null,
                  descriptionClassName: null,
                  descriptionClassNameOverride: null,
                },
              ],
              checkboxes: [
                {
                  id: 'agreeAllConsent',
                  name: 'agreeAllConsent',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'By signing up, I agree to Marriott\\\'s <a href="/about/terms-of-use-modal.mi" target="_blank">Terms of Use</a> and Marriott Bonvoy <a href="/loyalty/terms.mi" target="_blank">Terms and Conditions</a> and <u>confirm that I am 16 years or older</u>.\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/collectionUsePersonalData.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'south-korea-required-consents-data',
              name: 'south-korea-required-consents-data',
              index: 2,
              countries: ['KR', 'KR'],
              options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
              sectionType: 'required',
              showTopDivider: false,
              showBottomDivider: false,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: 'Please check all required consents!',
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [
                {
                  id: 'south-korea-required-consents-consents-headers',
                  name: 'south-korea-required-consents-consents-headers',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: ['join-now'],
                  headerContainerClassName: null,
                  headerContainerClassNameOverride: null,
                  header: 'Required Consents',
                  headerClassName: null,
                  headerClassNameOverride: null,
                  subHeader: null,
                  subHeaderClassName: null,
                  subHeaderClassNameOverride: null,
                  description:
                    'I understand that the following required consents are necessary to successfully make this reservation.',
                  descriptionClassName: null,
                  descriptionClassNameOverride: null,
                },
                {
                  id: 'south-korea-required-consents-headers-join-now',
                  name: 'south-korea-required-consents-headers-join-now',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: ['join-now'],
                  excludeOptions: null,
                  headerContainerClassName: null,
                  headerContainerClassNameOverride: null,
                  header: null,
                  headerClassName: null,
                  headerClassNameOverride: null,
                  subHeader: 'Required Consents',
                  subHeaderClassName: null,
                  subHeaderClassNameOverride: null,
                  description:
                    'I understand that the following required consents are necessary to successfully make this reservation.',
                  descriptionClassName: null,
                  descriptionClassNameOverride: null,
                },
              ],
              checkboxes: [
                {
                  id: 'collectPersonalDataConsentRequired',
                  name: 'collectPersonalDataConsentRequired',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown: 'Consent to the provision of Personal Data to third parties (Required)\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/collectionUsePersonalData.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: 'Please select required consents!',
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: '_self',
                },
                {
                  id: 'personalDataProvisionConsentRequiredData',
                  name: 'personalDataProvisionConsentRequiredData',
                  index: 2,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: ['join-now'],
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown: 'Consent to provision and cross-border provision of Personal Data (Required)\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/about/privacy/data-collection-use-disclosure.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: 'Please select mandatory consents!',
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: '_self',
                },
                {
                  id: 'personalDataProvisionConsentRequiredContent',
                  name: 'personalDataProvisionConsentRequiredContent',
                  index: 2,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: ['join-now'],
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown: 'Consent to provision and cross-border transfer of Personal Data (Required)\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: 'https://www.marriott.com/about/ccpa/modal.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'non-apec-countries-optional-consents',
              name: 'non-apec-countries-optional-consents',
              index: 1,
              countries: [
                'CY',
                'CX',
                'ZW',
                'SX',
                'GM',
                'CO',
                'TN',
                'LT',
                'ET',
                'ST',
                'GD',
                'BV',
                'UG',
                'AQ',
                'GU',
                'NG',
                'NU',
                'SA',
                'WS',
                'MV',
                'ES',
                'CZ',
                'TL',
                'VI',
                'BF',
                'JM',
                'NL',
                'IS',
                'PH',
                'TZ',
                'AO',
                'RE',
                'FI',
                'MZ',
                'GT',
                'SK',
                'TO',
                'SY',
                'GY',
                'MX',
                'TM',
                'GF',
                'DZ',
                'MT',
                'LC',
                'JO',
                'EH',
                'GE',
                'TF',
                'ME',
                'MA',
                'AL',
                'WF',
                'EG',
                'RW',
                'IO',
                'GA',
                'XK',
                'TC',
                'SG',
                'SI',
                'GB',
                'BB',
                'VU',
                'ZA',
                'IT',
                'LV',
                'PG',
                'MG',
                'AU',
                'CA',
                'BJ',
                'KY',
                'GP',
                'IQ',
                'BT',
                'VG',
                'MR',
                'HT',
                'AZ',
                'RO',
                'MN',
                'LS',
                'GE',
                'NZ',
                'CL',
                'KW',
                'BD',
                'AM',
                'MG',
                'SC',
                'BA',
                'US',
                'IN',
                'BR',
                'TR',
                'MX',
                'CH',
                'RU',
                'IT',
                'AE',
                'SA',
                'FR',
                'AU',
                'DE',
                'ZA',
                'NG',
                'PK',
                'ID',
                'GB',
                'AR',
                'LB',
                'MK',
                'NO',
                'PY',
                'PH',
                'TZ',
                'CI',
                'UY',
                'EC',
                'PE',
                'KH',
                'LA',
                'LK',
                'MV',
                'MZ',
                'OM',
                'GN',
                'VE',
                'KZ',
                'AO',
                'NC',
                'KG',
                'TG',
                'YE',
                'ET',
                'GA',
                'DZ',
                'TM',
                'TN',
                'NP',
                'TD',
                'MM',
                'UG',
                'CO',
                'GT',
                'HN',
                'PK',
                'GH',
                'SN',
                'JO',
                'MA',
                'SY',
                'ML',
                'SD',
                'IS',
                'FI',
                'EE',
                'LV',
                'LT',
                'SK',
                'SI',
                'HR',
                'BA',
                'ME',
                'AL',
                'RS',
                'XK',
                'MK',
                'MT',
                'CY',
                'BY',
                'UA',
                'MD',
                'GE',
                'AM',
                'AZ',
                'KZ',
                'UZ',
                'TM',
                'KG',
                'TJ',
                'AF',
                'PK',
                'IN',
                'NP',
                'LK',
                'BD',
                'BT',
                'MV',
                //'TW',
                'KP',
                'MN',
                'TH',
                'KH',
                'LA',
                'MM',
                'MY',
                'SG',
                'BN',
                'ID',
                'PH',
                'TL',
                'AU',
                'NZ',
                'PG',
                'FJ',
                'SB',
                'VU',
                'WS',
                'TO',
                'KI',
                'TV',
                'NR',
                'PW',
                'FM',
                'MH',
                'US',
                'CA',
                'MX',
                'GT',
                'SV',
                'HN',
                'NI',
                'CR',
                'PA',
                'CU',
                'DO',
                'HT',
                'JM',
                'TT',
                'BB',
                'LC',
                'GD',
                'VC',
                'KN',
                'AG',
                'BS',
                'DM',
                'PM',
                'BZ',
                'GY',
                'SR',
                'VE',
                'CO',
                'EC',
                'PE',
                'BR',
                'BO',
                'PY',
                'UY',
                'CL',
                'AR',
                'GL',
                'IS',
                'AR',
                'QA',
              ],
              options: ['join-now', 'non-member-reservation-instant-join'],
              sectionType: 'optional',
              showTopDivider: false,
              showBottomDivider: false,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [
                {
                  id: 'non-apec-required-consents-header-data',
                  name: 'non-apec-required-consents-header-data',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: ['join-now'],
                  excludeOptions: null,
                  headerContainerClassName: null,
                  headerContainerClassNameOverride: null,
                  header: 'Marriott Policies',
                  headerClassName: null,
                  headerClassNameOverride: 'header-class',
                  subHeader: null,
                  subHeaderClassName: null,
                  subHeaderClassNameOverride: null,
                  description: null,
                  descriptionClassName: null,
                  descriptionClassNameOverride: null,
                },
                {
                  id: 'non-apec-required-consents-header-content',
                  name: 'non-apec-required-consents-header-content',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: ['non-member-reservation-instant-join'],
                  excludeOptions: null,
                  headerContainerClassName: null,
                  headerContainerClassNameOverride: null,
                  header: 'Marriott Policies',
                  headerClassName: null,
                  headerClassNameOverride: 'header-class',
                  subHeader: 'Don’t miss account updates, program news and exclusive savings offers.',
                  subHeaderClassName: null,
                  subHeaderClassNameOverride: null,
                  description: null,
                  descriptionClassName: null,
                  descriptionClassNameOverride: null,
                },
              ],
              checkboxes: [
                {
                  id: 'subscriptionsOffers',
                  name: 'subscriptionsOffers',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I would like to receive personalized communications, including offers, details about promotions, and travel-related products from the Marriott Group via email.\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'subscriptions3rdParty',
                  name: 'subscriptions3rdParty',
                  index: 2,
                  forCountries: null,
                  excludeCountries: ['US'],
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I would like for the Marriott Group to share my personal data with Authorized Licensees, as defined in the Global Privacy Statement so I may receive offers and marketing via email.\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'non-apec-countries-required-consents',
              name: 'non-apec-countries-required-consents',
              index: 2,
              countries: [
                'CY',
                'CX',
                'ZW',
                'SX',
                'GM',
                'CO',
                'TN',
                'LT',
                'ET',
                'ST',
                'GD',
                'BV',
                'UG',
                'AQ',
                'GU',
                'NG',
                'NU',
                'SA',
                'WS',
                'MV',
                'ES',
                'CZ',
                'TL',
                'VI',
                'BF',
                'JM',
                'NL',
                'IS',
                'PH',
                'TZ',
                'AO',
                'RE',
                'FI',
                'MZ',
                'GT',
                'SK',
                'TO',
                'SY',
                'GY',
                'MX',
                'TM',
                'GF',
                'DZ',
                'MT',
                'LC',
                'JO',
                'EH',
                'GE',
                'TF',
                'ME',
                'MA',
                'AL',
                'WF',
                'EG',
                'RW',
                'IO',
                'GA',
                'XK',
                'TC',
                'SG',
                'SI',
                'GB',
                'BB',
                'VU',
                'ZA',
                'IT',
                'LV',
                'PG',
                'MG',
                'AU',
                'CA',
                'BJ',
                'KY',
                'GP',
                'IQ',
                'BT',
                'VG',
                'MR',
                'HT',
                'AZ',
                'RO',
                'MN',
                'LS',
                'GE',
                'NZ',
                'CL',
                'KW',
                'BD',
                'AM',
                'MG',
                'SC',
                'BA',
                'US',
                'IN',
                'BR',
                'TR',
                'MX',
                'CH',
                'RU',
                'IT',
                'AE',
                'SA',
                'FR',
                'AU',
                'DE',
                'ZA',
                'NG',
                'PK',
                'ID',
                'GB',
                'AR',
                'LB',
                'MK',
                'NO',
                'PY',
                'PH',
                'TZ',
                'CI',
                'UY',
                'EC',
                'PE',
                'KH',
                'LA',
                'LK',
                'MV',
                'MZ',
                'OM',
                'GN',
                'VE',
                'KZ',
                'AO',
                'NC',
                'KG',
                'TG',
                'YE',
                'ET',
                'GA',
                'DZ',
                'TM',
                'TN',
                'NP',
                'TD',
                'MM',
                'UG',
                'CO',
                'GT',
                'HN',
                'PK',
                'GH',
                'SN',
                'JO',
                'MA',
                'SY',
                'ML',
                'SD',
                'IS',
                'FI',
                'EE',
                'LV',
                'LT',
                'SK',
                'SI',
                'HR',
                'BA',
                'ME',
                'AL',
                'RS',
                'XK',
                'MK',
                'MT',
                'CY',
                'BY',
                'UA',
                'MD',
                'GE',
                'AM',
                'AZ',
                'KZ',
                'UZ',
                'TM',
                'KG',
                'TJ',
                'AF',
                'PK',
                'IN',
                'NP',
                'LK',
                'BD',
                'MV',
                //'TW',
                'KP',
                'MN',
                'TH',
                'KH',
                'LA',
                'MM',
                'MY',
                'SG',
                'BN',
                'ID',
                'PH',
                'TL',
                'AU',
                'NZ',
                'PG',
                'FJ',
                'SB',
                'VU',
                'WS',
                'TO',
                'KI',
                'TV',
                'NR',
                'PW',
                'FM',
                'MH',
                'US',
                'CA',
                'MX',
                'GT',
                'SV',
                'HN',
                'NI',
                'CR',
                'PA',
                'CU',
                'DO',
                'HT',
                'JM',
                'TT',
                'BB',
                'LC',
                'GD',
                'VC',
                'KN',
                'AG',
                'BS',
                'DM',
                'PM',
                'BZ',
                'GY',
                'SR',
                'VE',
                'CO',
                'EC',
                'PE',
                'BR',
                'BO',
                'PY',
                'UY',
                'CL',
                'AR',
                'GL',
                'IS',
                'AR',
                'QA',
              ],
              options: ['join-now', 'non-member-reservation'],
              sectionType: 'required',
              showTopDivider: false,
              showBottomDivider: false,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [
                {
                  id: 'non-apec-required-consents-header-content-second',
                  name: 'non-apec-required-consents-header-content-second',
                  index: 1,
                  forCountries: ['join-now'],
                  excludeCountries: null,
                  forOptions: ['non-member-reservation'],
                  excludeOptions: null,
                  headerContainerClassName: null,
                  headerContainerClassNameOverride: null,
                  header: 'Marriott Policies',
                  headerClassName: null,
                  headerClassNameOverride: 'header-class',
                  subHeader: 'Don’t miss account updates, program news and exclusive savings offers.',
                  subHeaderClassName: null,
                  subHeaderClassNameOverride: null,
                  description:
                    'I understand by providing ALL of the optional consents below, I can receive information relating to offers or promotions from the Marriott Group and third parties. I understand that I may deny consent, in which case I may be unable to receive such information. However, other products and services provided by the Marriott Group will continue to be available.',
                  descriptionClassName: null,
                  descriptionClassNameOverride: null,
                },
              ],
              checkboxes: [
                {
                  id: 'non-apec-countries-accountTermsAndConditionsData',
                  name: 'non-apec-countries-accountTermsAndConditionsData',
                  index: 3,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: ['join-now'],
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: true,
                  showCheckbox: false,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      '<p>By signing up, I agree to Marriott\\\'s <a href="/about/terms-of-use-modal.mi" target="_blank"><u>Terms of Use</u></a> and Marriott Bonvoy <a href="/loyalty/terms.mi" target="_blank"><u>Terms and Conditions</u></a> and <u>confirm that I am 16 years or older</u>.</p>\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'non-apec-countries-accountTermsAndConditionsContent',
                  name: 'non-apec-countries-accountTermsAndConditionsContent',
                  index: 3,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: ['non-member-reservation'],
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: true,
                  showCheckbox: false,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'By signing up, I agree to Marriott\\\'s&nbsp;<a href="/about/terms-of-use-modal.mi">Terms of Use</a>,&nbsp;<u><a href="/marriott/privacy-modal.mi" target="_self">Privacy Statement</a>,</u> <u><a href="/marriott-rewards/data-protection.mi" target="_blank">Data Protection Clause</a></u> and acknowledge the <a href="/about/ccpa/modal.mi" target="_blank">California Notice of Financial Incentive</a>.</p>\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'vietnam-required-consents',
              name: 'vietnam-required-consents',
              index: 1,
              countries: ['VN', 'VN'],
              options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
              sectionType: 'required',
              showTopDivider: true,
              showBottomDivider: true,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [
                {
                  id: 'required-consents-header-contents',
                  name: 'required-consents-header-contents',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: ['non-member-reservation'],
                  headerContainerClassName: null,
                  headerContainerClassNameOverride: null,
                  header: 'Required Consents',
                  headerClassName: null,
                  headerClassNameOverride: null,
                  subHeader:
                    'By ticking the boxes below, I acknowledge and understand that the following required consents are necessary to make a reservation.',
                  subHeaderClassName: null,
                  subHeaderClassNameOverride: null,
                  description: null,
                  descriptionClassName: null,
                  descriptionClassNameOverride: null,
                },
              ],
              checkboxes: [
                {
                  id: 'vnPersonalDataRequiredData',
                  name: 'vnPersonalDataRequiredData',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: ['non-member-reservation'],
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I have read and agreed to Marriott’s <a href="/about/terms-of-use-modal.mi" target="_blank">Terms of Use</a> and my personal data being collected, used, shared and transferred in accordance with Marriott’s <a href="/marriott/privacy-modal.mi" target="_blank">Global Privacy Statement</a>. (Required)\',\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: 'Please select required consent!',
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'vnCrossBorderPersonalDataRequiredData',
                  name: 'vnCrossBorderPersonalDataRequiredData',
                  index: 2,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: ['non-member-reservation'],
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I agree to the cross-border transfer of my personal data to the <a href=\\"/about/privacy/marriott-group/modal.mi\\" target=\\"_parent\\">Marriott Group</a> for the purposes described in Marriott’s <a href=\\"/marriott/privacy-modal.mi\\" target=\\"_parent\\" title=\\"privacy\\">Global Privacy Statement</a>, including my enrollment in Marriott Bonvoy and my receipt of membership services and related benefits. (Required)\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: 'Please select required consent!',
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'vnRequiredPersonalData',
                  name: 'vnRequiredPersonalData',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: ['non-member-reservation'],
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I have read and agreed to Marriott’s <a href=\\"/about/terms-of-use-modal.mi\\" target=\\"_blank\\">Terms of Use</a> and my personal data being collected, used, shared and transferred in accordance with Marriott’s <a href=\\"/marriott/privacy-modal.mi\\" target=\\"_blank\\">Global Privacy Statement</a>. (Required)\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: 'Please select required consent!',
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'vnCrossBorderRequiredPersonalData',
                  name: 'vnCrossBorderRequiredPersonalData',
                  index: 2,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: ['non-member-reservation'],
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I agree to the cross-border transfer of my personal data to the <a href=\\"/about/privacy/marriott-group/modal.mi\\" target=\\"_blank\\">Marriott Group</a> for the purposes described in Marriott’s <a href=\\"/marriott/privacy-modal.mi\\" target=\\"_blank\\">Global Privacy Statement</a>, including the completion of my reservation and the provision of hotel accommodation and related services. (Required)\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: 'Please select required consent!',
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'china-privacy-consents-data',
              name: 'china-privacy-consents-data',
              index: 1,
              countries: ['CN'],
              options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
              sectionType: 'agreeAll',
              showTopDivider: true,
              showBottomDivider: false,
              containerClassName: 'm-china-consents mt-0 mb-2',
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [],
              checkboxes: [
                {
                  id: 'agreeAllConsent',
                  name: 'agreeAllConsent',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown: 'Agree to all:',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'HK-consents',
              name: 'HK-consents',
              index: 3,
              countries: ['HK', 'MO', 'TW'],
              options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
              sectionType: 'optional',
              showTopDivider: false,
              showBottomDivider: false,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [],
              checkboxes: [
                {
                  id: 'HKNewConsent',
                  name: 'HKNewConsent',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: false,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'By signing up, I confirm that I am at least 18 years old, I agree to Marriott Groups Terms of Use and Loyalty Program Terms & Conditions, I also acknowledge Marriotts Privacy Statement located in the Privacy Center.',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'HKNewCollectPersonalDataConsentOptional',
                  name: 'HKNewCollectPersonalDataConsentOptional',
                  index: 2,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown: 'I agree to receive account updates, program news and offers from the Marriott Group.',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'HKNewPersonalDataProvisionConsentOptional',
                  name: 'HKNewPersonalDataProvisionConsentOptional',
                  index: 3,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown: 'I agree to receive account updates, program news and offers from the Marriott Group.',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'south-korea-privacy-consents-data',
              name: 'south-korea-privacy-consents-data',
              index: 1,
              countries: ['KR'],
              options: ['join-now-bundle'],
              sectionType: 'agreeAll',
              showTopDivider: true,
              showBottomDivider: true,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [
                {
                  id: 'south-korea-privacy-consents-consents-join-now-bundle-headers',
                  name: 'south-korea-privacy-consents-consents-join-now-bundle-headers',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: ['join-now-bundle'],
                  excludeOptions: null,
                  headerContainerClassName: null,
                  headerContainerClassNameOverride: null,
                  header: 'Privacy Consents',
                  headerClassName: null,
                  headerClassNameOverride: null,
                  subHeader: null,
                  subHeaderClassName: null,
                  subHeaderClassNameOverride: null,
                  description: null,
                  descriptionClassName: null,
                  descriptionClassNameOverride: null,
                },
              ],
              checkboxes: [
                {
                  id: 'agreeAllConsent',
                  name: 'agreeAllConsent',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'By signing up, I agree to Marriott\\\'s <a href="/about/terms-of-use-modal.mi" target="_blank">Terms of Use</a> and Marriott Bonvoy <a href="/loyalty/terms.mi" target="_blank">Terms and Conditions</a> and <u>confirm that I am 16 years or older</u>.\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/collectionUsePersonalData.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'new-us-consents',
              name: 'new-us-consents',
              index: 3,
              countries: ['US', 'GB', 'UY', 'KR'],
              options: ['join-now-bundle'],
              sectionType: 'required',
              showTopDivider: false,
              showBottomDivider: false,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [],
              checkboxes: [
                {
                  id: 'newUSPersonalData',
                  name: 'newUSPersonalData',
                  index: 1,
                  forCountries: ['US'],
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: true,
                  showCheckbox: false,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'By joining the Marriott Bonvoy program, I agree that the Marriott Group (“Marriott”) may use my personal data to send me personalized promotional offers via email, SMS, and other channels and through personalized advertising on Marriott and Advertising Partners’ platforms. These messages may be tailored to me based on my purchases, use of Marriott services and properties, related activities, and information from third parties. I acknowledge that Marriott will handle my personal data in accordance with the Marriott Group Global Privacy Statement',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'iAgreeTOC',
                  name: 'iAgreeTOC',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: true,
                  showCheckbox: false,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'By signing up, I agree to Marriott\\\'s <a href="/about/terms-of-use-modal.mi" target="_blank">Terms of Use</a> and Marriott Bonvoy <a href="/loyalty/terms.mi" target="_blank">Terms and Conditions</a>. I also acknowledge Marriott&apos;s Privacy Statement located in the <a href="/loyalty/terms/privacy/collectionUsePersonalData.mi" target="_blank">Privacy Center</a> and the <a href="/loyalty/terms/privacy/collectionUsePersonalData.mi" target="_blank">California Notice of Financial Incentive</a>.\n\n ',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'non-us-non-bundled',
              name: 'non-us-non-bundled',
              index: 1,
              countries: ['GB', 'KR'],
              options: ['join-now-bundle'],
              sectionType: 'unified',
              showTopDivider: false,
              showBottomDivider: false,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [
                {
                  id: 'non-us-non-bundled-header-contents',
                  name: 'non-us-non-bundled-header-contents',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: [],
                  headerContainerClassName: null,
                  headerContainerClassNameOverride: null,
                  header: null,
                  headerClassName: null,
                  headerClassNameOverride: null,
                  subHeader: null,
                  subHeaderClassName: null,
                  subHeaderClassNameOverride: null,
                  description:
                    'I agree that the Marriott Group (“Marriott”) may use my personal data to send me personalized promotional messages and offers via email, SMS, and other channels, and through personalized advertising on Marriott and third-party platforms. These messages may be tailored to me based on my purchases, use of Marriott services and properties, related activities, and information from third parties.',
                  descriptionClassName: null,
                  descriptionClassNameOverride: null,
                },
              ],
              checkboxes: [
                {
                  id: 'agreeAllUnifiedConsent',
                  name: 'agreeAllUnifiedConsent',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown: 'Agree To All',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'emailUnifiedConsent',
                  name: 'emailUnifiedConsent',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: true,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown: 'Email marketing',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/collectionUsePersonalData.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'smsUnifiedConsent',
                  name: 'smsUnifiedConsent',
                  index: 1,
                  forCountries: null,
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: true,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown: 'Sms marketing',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/collectionUsePersonalData.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'postalUnifiedConsent',
                  name: 'postalUnifiedConsent',
                  index: 1,
                  forCountries: ['KR'],
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown: 'Postal marketing',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/collectionUsePersonalData.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'pushUnifiedConsent',
                  name: 'pushUnifiedConsent',
                  index: 1,
                  forCountries: ['KR'],
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: false,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown: 'Push marketing',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: '/loyalty/terms/privacy/collectionUsePersonalData.mi',
                  termsLinkLabel: 'Terms',
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
            {
              id: 'non-us-bundled-consents',
              name: 'non-us-bundled-consents',
              index: 2,
              countries: ['UY', 'GB', 'KR'],
              options: ['join-now-bundle'],
              sectionType: 'optional',
              showTopDivider: false,
              showBottomDivider: false,
              containerClassName: null,
              containerClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              headers: [],
              checkboxes: [
                {
                  id: 'MICON',
                  name: 'MICON',
                  index: 1,
                  forCountries: ['UY'],
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: true,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I agree that the Marriott Group (“Marriott”) may use my personal data to send me personalized promotional messages and offers via email, SMS, and other channels, and through personalized advertising on Marriott and third-party platforms. These messages may be tailored to me based on my purchases, use of Marriott services and properties, related activities, and information from third parties.',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'TPCON',
                  name: 'TPCON',
                  index: 1,
                  forCountries: ['UY'],
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: true,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I agree that Marriott may share my personal data with Authorized Licensees and Advertising Partners, as those terms are defined in Marriott’s Global Privacy Statement (“Privacy Statement”). These third parties include co-branded credit card companies and other companies that may be of interest to me, so that those companies can send me promotional messages, personalized advertising and offers, invites to events, and other information that may be of use to me.',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
                {
                  id: 'nonUsNonBundledConsent',
                  name: 'nonUsNonBundledConsent',
                  index: 1,
                  forCountries: ['GB', 'KR'],
                  excludeCountries: null,
                  forOptions: null,
                  excludeOptions: null,
                  isDisabled: false,
                  defaultChecked: true,
                  showCheckbox: true,
                  checkboxLabelContainerClassName: null,
                  checkboxLabelContainerClassNameOverride: null,
                  checkboxContainerClassName: null,
                  checkboxContainerClassNameOverride: null,
                  checkboxClassName: null,
                  checkboxClassNameOverride: null,
                  label: {
                    markdown:
                      'I agree that Marriott may share my personal data with Authorized Licensees and Advertising Partners, as those terms are defined in Marriott’s Global Privacy Statement (“Privacy Statement”). These third parties include co-branded credit card companies and other companies that may be of interest to me, so that those companies can send me promotional messages, personalized advertising and offers, invites to events, and other information that may be of use to me.',
                  },
                  labelClassName: null,
                  labelClassNameOverride: null,
                  termsLink: null,
                  termsLinkLabel: null,
                  termsLinkLabelClassName: null,
                  termsLinkLabelClassNameOverride: null,
                  errorMessage: null,
                  errorMessageClassName: null,
                  errorMessageClassNameOverride: null,
                  termsLinkTarget: null,
                },
              ],
            },
          ],
        },
      ],
    },
  },
};

export const CountriesAndCountryCode = [
  {
    value: 'AF',
    label: 'Afghanistan',
  },
  {
    value: 'AX',
    label: 'Aland Islands',
  },
  {
    value: 'AL',
    label: 'Albania',
  },
  {
    value: 'DZ',
    label: 'Algeria',
  },
  {
    value: 'AD',
    label: 'Andorra',
  },
  {
    value: 'AO',
    label: 'Angola',
  },
  {
    value: 'AI',
    label: 'Anguilla',
  },
  {
    value: 'AQ',
    label: 'Antarctica',
  },
  {
    value: 'AG',
    label: 'Antigua',
  },
  {
    value: 'AR',
    label: 'Argentina',
  },
  {
    value: 'AM',
    label: 'Armenia',
  },
  {
    value: 'AW',
    label: 'Aruba',
  },
  {
    value: 'AU',
    label: 'Australia',
  },
  {
    value: 'AT',
    label: 'Austria',
  },
  {
    value: 'AZ',
    label: 'Azerbaijan',
  },
  {
    value: 'BS',
    label: 'Bahamas',
  },
  {
    value: 'BH',
    label: 'Bahrain',
  },
  {
    value: 'BD',
    label: 'Bangladesh',
  },
  {
    value: 'BB',
    label: 'Barbados',
  },
  {
    value: 'BY',
    label: 'Belarus',
  },
  {
    value: 'BE',
    label: 'Belgium',
  },
  {
    value: 'BZ',
    label: 'Belize',
  },
  {
    value: 'BJ',
    label: 'Benin',
  },
  {
    value: 'BM',
    label: 'Bermuda',
  },
  {
    value: 'BT',
    label: 'Bhutan',
  },
  {
    value: 'BO',
    label: 'Bolivia',
  },
  {
    value: 'BQ',
    label: 'Bonaire',
  },
  {
    value: 'BA',
    label: 'Bosnia Hercegovina',
  },
  {
    value: 'BW',
    label: 'Botswana',
  },
  {
    value: 'BV',
    label: 'Bouvet Island',
  },
  {
    value: 'IO',
    label: 'Br Indian Ocean Terr',
  },
  {
    value: 'BR',
    label: 'Brazil',
  },
  {
    value: 'VG',
    label: 'British Virgin Islan',
  },
  {
    value: 'BN',
    label: 'Brunei Darussalam',
  },
  {
    value: 'BG',
    label: 'Bulgaria',
  },
  {
    value: 'BF',
    label: 'Burkina Faso',
  },
  {
    value: 'BI',
    label: 'Burundi',
  },
  {
    value: 'KH',
    label: 'Cambodia',
  },
  {
    value: 'CM',
    label: 'Cameroon',
  },
  {
    value: 'CA',
    label: 'Canada',
  },
  {
    value: 'CV',
    label: 'Cape Verde',
  },
  {
    value: 'KY',
    label: 'Cayman Islands',
  },
  {
    value: 'CF',
    label: 'Cent Africa Republic',
  },
  {
    value: 'TD',
    label: 'Chad',
  },
  {
    value: 'CL',
    label: 'Chile',
  },
  {
    value: 'CN',
    label: 'China',
  },
  {
    value: 'CX',
    label: 'Christmas Island',
  },
  {
    value: 'CC',
    label: 'Cocos Islands',
  },
  {
    value: 'CO',
    label: 'Colombia',
  },
  {
    value: 'KM',
    label: 'Comoro Islands',
  },
  {
    value: 'CG',
    label: 'Congo',
  },
  {
    value: 'CD',
    label: 'Congo',
  },
  {
    value: 'CK',
    label: 'Cook Islands',
  },
  {
    value: 'CR',
    label: 'Costa Rica',
  },
  {
    value: 'HR',
    label: 'Croatia',
  },
  {
    value: 'CU',
    label: 'Cuba',
  },
  {
    value: 'CW',
    label: 'Curacao',
  },
  {
    value: 'CY',
    label: 'Cyprus',
  },
  {
    value: 'CZ',
    label: 'Czech Republic',
  },
  {
    value: 'DK',
    label: 'Denmark',
  },
  {
    value: 'DJ',
    label: 'Djibouti',
  },
  {
    value: 'DM',
    label: 'Dominica',
  },
  {
    value: 'DO',
    label: 'Dominican Republic',
  },
  {
    value: 'EC',
    label: 'Ecuador',
  },
  {
    value: 'EG',
    label: 'Egypt',
  },
  {
    value: 'SV',
    label: 'El Salvador',
  },
  {
    value: 'GQ',
    label: 'Equatorial Guinea',
  },
  {
    value: 'ER',
    label: 'Eritrea',
  },
  {
    value: 'EE',
    label: 'Estonia',
  },
  {
    value: 'ET',
    label: 'Ethiopia',
  },
  {
    value: 'FO',
    label: 'Faeroe Islands',
  },
  {
    value: 'FK',
    label: 'Falkland Islands',
  },
  {
    value: 'FJ',
    label: 'Fiji',
  },
  {
    value: 'FI',
    label: 'Finland',
  },
  {
    value: 'FR',
    label: 'France',
  },
  {
    value: 'GF',
    label: 'French Guiana',
  },
  {
    value: 'PF',
    label: 'French Polynesia',
  },
  {
    value: 'TF',
    label: 'French Southern Terr',
  },
  {
    value: 'GA',
    label: 'Gabon',
  },
  {
    value: 'GM',
    label: 'Gambia',
  },
  {
    value: 'XA',
    label: 'Gaza',
  },
  {
    value: 'GE',
    label: 'Georgia',
  },
  {
    value: 'DE',
    label: 'Germany',
  },
  {
    value: 'GH',
    label: 'Ghana',
  },
  {
    value: 'GI',
    label: 'Gibraltar',
  },
  {
    value: 'GR',
    label: 'Greece',
  },
  {
    value: 'GL',
    label: 'Greenland',
  },
  {
    value: 'GD',
    label: 'Grenada',
  },
  {
    value: 'GP',
    label: 'Guadeloupe',
  },
  {
    value: 'GU',
    label: 'Guam',
  },
  {
    value: 'GT',
    label: 'Guatemala',
  },
  {
    value: 'GG',
    label: 'Guernsey',
  },
  {
    value: 'GN',
    label: 'Guinea',
  },
  {
    value: 'GW',
    label: 'Guinea-bissau',
  },
  {
    value: 'GY',
    label: 'Guyana',
  },
  {
    value: 'HT',
    label: 'Haiti',
  },
  {
    value: 'HM',
    label: 'Heard & Mcdonald Isl',
  },
  {
    value: 'HN',
    label: 'Honduras',
  },
  {
    value: 'HK',
    label: 'Hong Kong',
  },
  {
    value: 'HU',
    label: 'Hungary',
  },
  {
    value: 'IS',
    label: 'Iceland',
  },
  {
    value: 'IN',
    label: 'India',
  },
  {
    value: 'XI',
    label: 'Indian Ocean Islands',
  },
  {
    value: 'ID',
    label: 'Indonesia',
  },
  {
    value: 'IR',
    label: 'Iran',
  },
  {
    value: 'IQ',
    label: 'Iraq',
  },
  {
    value: 'IE',
    label: 'Ireland',
  },
  {
    value: 'IM',
    label: 'Isle Of Man',
  },
  {
    value: 'IL',
    label: 'Israel',
  },
  {
    value: 'IT',
    label: 'Italy',
  },
  {
    value: 'CI',
    label: 'Ivory Coast',
  },
  {
    value: 'JM',
    label: 'Jamaica',
  },
  {
    value: 'JP',
    label: 'Japan',
  },
  {
    value: 'JE',
    label: 'Jersey',
  },
  {
    value: 'JO',
    label: 'Jordan',
  },
  {
    value: 'KZ',
    label: 'Kazakhstan',
  },
  {
    value: 'KE',
    label: 'Kenya',
  },
  {
    value: 'KI',
    label: 'Kiribati',
  },
  {
    value: 'KP',
    label: 'Korea, Dem. Peoples',
  },
  {
    value: 'KR',
    label: 'Korea, Republic Of',
  },
  {
    value: 'XK',
    label: 'Kosovo',
  },
  {
    value: 'KW',
    label: 'Kuwait',
  },
  {
    value: 'KG',
    label: 'Kyrgyzstan',
  },
  {
    value: 'LP',
    label: 'Lao P D R',
  },
  {
    value: 'LA',
    label: 'Laos',
  },
  {
    value: 'LV',
    label: 'Latvia',
  },
  {
    value: 'LB',
    label: 'Lebanon',
  },
  {
    value: 'LW',
    label: 'Leeward Islands',
  },
  {
    value: 'LS',
    label: 'Lesotho',
  },
  {
    value: 'LR',
    label: 'Liberia',
  },
  {
    value: 'LY',
    label: 'Libya',
  },
  {
    value: 'LI',
    label: 'Liechtenstein',
  },
  {
    value: 'LT',
    label: 'Lithuania',
  },
  {
    value: 'LU',
    label: 'Luxembourg',
  },
  {
    value: 'MO',
    label: 'Macau',
  },
  {
    value: 'MK',
    label: 'Macedonia',
  },
  {
    value: 'MG',
    label: 'Madagascar',
  },
  {
    value: 'MW',
    label: 'Malawi',
  },
  {
    value: 'MY',
    label: 'Malaysia',
  },
  {
    value: 'MV',
    label: 'Maldives',
  },
  {
    value: 'ML',
    label: 'Mali',
  },
  {
    value: 'MT',
    label: 'Malta',
  },
  {
    value: 'MQ',
    label: 'Martinique',
  },
  {
    value: 'MR',
    label: 'Mauritania',
  },
  {
    value: 'MU',
    label: 'Mauritius',
  },
  {
    value: 'YT',
    label: 'Mayotte',
  },
  {
    value: 'MX',
    label: 'Mexico',
  },
  {
    value: 'MD',
    label: 'Moldova',
  },
  {
    value: 'MC',
    label: 'Monaco',
  },
  {
    value: 'MN',
    label: 'Mongolia',
  },
  {
    value: 'ME',
    label: 'Montenegro',
  },
  {
    value: 'MS',
    label: 'Montserrat',
  },
  {
    value: 'MA',
    label: 'Morocco',
  },
  {
    value: 'MZ',
    label: 'Mozambique',
  },
  {
    value: 'MM',
    label: 'Myanmar',
  },
  {
    value: 'NA',
    label: 'Namibia',
  },
  {
    value: 'NR',
    label: 'Nauru',
  },
  {
    value: 'NP',
    label: 'Nepal',
  },
  {
    value: 'AN',
    label: 'Netherland Antilles',
  },
  {
    value: 'NL',
    label: 'Netherlands',
  },
  {
    value: 'NC',
    label: 'New Caledonia',
  },
  {
    value: 'NZ',
    label: 'New Zealand',
  },
  {
    value: 'NI',
    label: 'Nicaragua',
  },
  {
    value: 'NE',
    label: 'Niger',
  },
  {
    value: 'NG',
    label: 'Nigeria',
  },
  {
    value: 'NU',
    label: 'Niue',
  },
  {
    value: 'NF',
    label: 'Norfolk Island',
  },
  {
    value: 'NO',
    label: 'Norway',
  },
  {
    value: 'OM',
    label: 'Oman',
  },
  {
    value: 'PK',
    label: 'Pakistan',
  },
  {
    value: 'PA',
    label: 'Panama',
  },
  {
    value: 'PG',
    label: 'Papua New Guinea',
  },
  {
    value: 'PY',
    label: 'Paraguay',
  },
  {
    value: 'PE',
    label: 'Peru',
  },
  {
    value: 'PH',
    label: 'Philippines',
  },
  {
    value: 'PN',
    label: 'Pitcairn Island',
  },
  {
    value: 'PL',
    label: 'Poland',
  },
  {
    value: 'PT',
    label: 'Portugal',
  },
  {
    value: 'PR',
    label: 'Puerto Rico',
  },
  {
    value: 'QA',
    label: 'Qatar',
  },
  {
    value: 'RE',
    label: 'Reunion',
  },
  {
    value: 'RO',
    label: 'Romania',
  },
  {
    value: 'RU',
    label: 'Russia',
  },
  {
    value: 'RW',
    label: 'Rwanda',
  },
  {
    value: 'GS',
    label: 'S Georgia-s Sandwich',
  },
  {
    value: 'BL',
    label: 'Saint Barthelemy',
  },
  {
    value: 'LC',
    label: 'Saint Lucia',
  },
  {
    value: 'MF',
    label: 'Saint Martin',
  },
  {
    value: 'WS',
    label: 'Samoa',
  },
  {
    value: 'SM',
    label: 'San Marino',
  },
  {
    value: 'ST',
    label: 'Sao Tome-principe',
  },
  {
    value: 'SA',
    label: 'Saudi Arabia',
  },
  {
    value: 'SN',
    label: 'Senegal',
  },
  {
    value: 'RS',
    label: 'Serbia',
  },
  {
    value: 'SC',
    label: 'Seychelles',
  },
  {
    value: 'SL',
    label: 'Sierra Leone',
  },
  {
    value: 'SG',
    label: 'Singapore',
  },
  {
    value: 'SK',
    label: 'Slovakia',
  },
  {
    value: 'SI',
    label: 'Slovenia',
  },
  {
    value: 'SB',
    label: 'Solomon Islands',
  },
  {
    value: 'SO',
    label: 'Somalia',
  },
  {
    value: 'ZA',
    label: 'South Africa',
  },
  {
    value: 'SS',
    label: 'South Sudan',
  },
  {
    value: 'ES',
    label: 'Spain',
  },
  {
    value: 'LK',
    label: 'Sri Lanka',
  },
  {
    value: 'SH',
    label: 'St Helena',
  },
  {
    value: 'KN',
    label: 'St Kitts-nevis',
  },
  {
    value: 'SX',
    label: 'St Maarten',
  },
  {
    value: 'PM',
    label: 'St Pierre & Miquelon',
  },
  {
    value: 'VC',
    label: 'St Vincent & The Gre',
  },
  {
    value: 'SD',
    label: 'Sudan',
  },
  {
    value: 'SR',
    label: 'Suriname',
  },
  {
    value: 'SJ',
    label: 'Svalbard & Jan Mayen',
  },
  {
    value: 'SZ',
    label: 'Swaziland',
  },
  {
    value: 'SE',
    label: 'Sweden',
  },
  {
    value: 'CH',
    label: 'Switzerland',
  },
  {
    value: 'SY',
    label: 'Syrian Arab Republic',
  },
  {
    value: 'TW',
    label: 'Taiwan',
  },
  {
    value: 'TJ',
    label: 'Tajikstan',
  },
  {
    value: 'TZ',
    label: 'Tanzania',
  },
  {
    value: 'TH',
    label: 'Thailand',
  },
  {
    value: 'TL',
    label: 'Timor-leste',
  },
  {
    value: 'TG',
    label: 'Togo',
  },
  {
    value: 'TK',
    label: 'Tokelau',
  },
  {
    value: 'TO',
    label: 'Tonga',
  },
  {
    value: 'TT',
    label: 'Trinidad & Tobago',
  },
  {
    value: 'TN',
    label: 'Tunisia',
  },
  {
    value: 'TR',
    label: 'Turkey',
  },
  {
    value: 'TM',
    label: 'Turkmenistan',
  },
  {
    value: 'TC',
    label: 'Turks & Caicos',
  },
  {
    value: 'TV',
    label: 'Tuvalu',
  },
  {
    value: 'UG',
    label: 'Uganda',
  },
  {
    value: 'UA',
    label: 'Ukraine',
  },
  {
    value: 'AE',
    label: 'United Arab Emirates',
  },
  {
    value: 'GB',
    label: 'United Kingdom',
  },
  {
    value: 'UV',
    label: 'Upper Volta',
  },
  {
    value: 'UY',
    label: 'Uruguay',
  },
  {
    value: 'US',
    label: 'USA',
  },
  {
    value: 'UZ',
    label: 'Uzbekistan',
  },
  {
    value: 'VU',
    label: 'Vanuatu',
  },
  {
    value: 'VA',
    label: 'Vatican City',
  },
  {
    value: 'VE',
    label: 'Venezuela',
  },
  {
    value: 'VN',
    label: 'Vietnam',
  },
  {
    value: 'VI',
    label: 'Virgin Islands',
  },
  {
    value: 'WF',
    label: 'Wallis & Futuna',
  },
  {
    value: 'PS',
    label: 'West Bank',
  },
  {
    value: 'EH',
    label: 'Western Sahara',
  },
  {
    value: 'YE',
    label: 'Yemen, Republic Of ',
  },
  {
    value: 'ZM',
    label: 'Zambia',
  },
  {
    value: 'ZW',
    label: 'Zimbabwe',
  },
];
